var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "table",
      {
        staticClass: "table table-striped table-bordered w-100",
        style: "font-size: " + this.dtFontSize + "px;",
        attrs: { id: _vm.id },
      },
      [
        _c("thead", [
          _c(
            "tr",
            _vm._l(_vm.columnas, function (columna, k) {
              return _c("th", { key: k }, [
                _c("i", { class: columna.clase }),
                _vm._v(" " + _vm._s(columna.nombre) + "\r\n                "),
              ])
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_vm.datos_table, function (data, k) {
            return _c(
              "tr",
              { key: k },
              _vm._l(_vm.columnas, function (columna, j) {
                return _c(
                  "td",
                  { key: j },
                  [
                    columna.slot
                      ? _vm._t(columna.nombre_variable, null, { data: data })
                      : _c("div", [
                          _c("span", [
                            _vm._v(_vm._s(data[columna.nombre_variable])),
                          ]),
                        ]),
                  ],
                  2
                )
              }),
              0
            )
          }),
          0
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }